import {MI} from "../init";
import {GameConfig} from "../game/GameConfig";
import {PreinfoSlide} from "./PreinfoSlide";
import {ServerCfg} from "../ServerCfg";
import {ReelPrinter} from "../reel/ReelPrinter";
import {SpinReels} from "../reel/SpinReels";
import {ReelsSpinner} from "../reel/ReelsSpinner";
import {GameAssets} from "../game/GameAssets";
import {FsAnims} from "../game/FsAnims";
import {Arrow} from "../symbol/Arrow";
import {systemConfig} from "../../framework/src/engine/madnes/madnes_variables";
import {CONFIG_PARAMS} from "../../framework/src/system/SystemConfig";

/**
 * @constructor
 * @extends {PreinfoSlide}
 */

export function PreinfoFreespins() {
	PreinfoSlide.call(this);

	/** @type {Array<MadnesObject>} */
	this._stickSymbols = [];

	/** @type {Array<MadnesTimer>} */
	this._timers = [];

	this._initMatrix = [
		[3, 5, 6],
		[5, 8, 3],
		[4, 3, 7],
		[1, 2, 3],
		[3, 0, 2]
	];

	/** @type {GameConfig} */
	this._gameConfig;

	/** @type {GameAssets} */
	this._assets;

	/** @type {FsAnims} */
	this._fsAnims;
};

PreinfoFreespins.prototype = Object.create(PreinfoSlide.prototype);
PreinfoFreespins.prototype.constructor = PreinfoFreespins;

/** @returns {GameConfig} */
PreinfoFreespins.prototype._getGameConfig = function() {

	var gameCfg = new GameConfig();
	var y = 195;

	gameCfg.symbolHeight = 105;
	gameCfg.reelsPositions = [
		{ 'x': 730, 'y': y },
		{ 'x': 842, 'y': y },
		{ 'x': 960, 'y': y },
		{ 'x': 1076, 'y': y },
		{ 'x': 1192, 'y': y }
	];

	gameCfg.symbolOffsetY = 0;

	gameCfg.ropesPos = [670, 783, 900, 1017, 1130, 1246];

	return gameCfg;
};

PreinfoFreespins.prototype._getServerConfig = function() {

	var serverConfig = new ServerCfg();
	serverConfig.setServerConfig(MI.server.getConfig());
	serverConfig.setReelMatrix(this._initMatrix);

	return serverConfig;
};

/**
 * @param {SymbolsManager} symbolsManager
 * @param {MadnesGroup} symbolsGroup
 */
PreinfoFreespins.prototype.create = function(symbolsManager, symbolsGroup) {
	if (systemConfig.get(CONFIG_PARAMS.LANGUAGE) === "es") {
		this._createBtns(960, 180, "free-spins_es");
	} else {
		this._createBtns(960, 180, "free-spins");
	}

	this._symbolsManager = symbolsManager;
	this._symbolsGroup = symbolsGroup;

	this._gameConfig = this._getGameConfig();
	var reelPrinter = new ReelPrinter(this._gameConfig);

	this._serverConfig = this._getServerConfig();

	this._spinReels = new SpinReels();
//	this._spinReels.reelsSymbolsCount = 5;
	this._spinReels.init(reelPrinter, this._gameConfig, this._serverConfig, this._symbolsManager);

	this._spinReels.setSymbolsGroup(this._symbolsGroup);
	this._spinReels.setSymbolsScale(0.5);
	this._spinReels.setServerReels(this._getServerReels());
	this._spinReels.createReels();

	this._reelsSpinner = new ReelsSpinner(this._spinReels);
};

PreinfoFreespins.prototype.createFires = function()
{
	var _self = this;

	this._assets = new GameAssets(this._gameConfig);
	this._assets.createFsGroup();

	this._fsAnims = new FsAnims();

//	this._fsAnims.setFsFiresComplete(function() {
//		_self._assets.showFireRopes();
//	});

	this._fsAnims.create(this._assets.getFsGroup(), 330, 40, 380, 1);
	//this._fsAnims.createLabel(956, 406, 1);
};

PreinfoFreespins.prototype.createFSLabel = function() {
	this._fsAnims.createLabel(956, 406, 1);
};

PreinfoFreespins.prototype.createRopes = function() {
	this._assets.createFireRopes(220, 1.06);
};

PreinfoFreespins.prototype.run = function() {

	var _self = this;

	if(this._animRunning || !this._reelsSpinner) {
		return;
	}

	this._animRunning = true;

	this.setActive(true);

//	console.time('t');

	this._removeTimers();

	this._reelsSpinner.spin().then(function() {

		if(!_self._reelsSpinner)
		{
			return;
		}

		return _self._reelsStopFs([[1, 2], [2, 2], [3, 1]]).then(function() {

			if(!_self._reelsSpinner)
			{
				return;
			}

			MI.createTimer().add(function() {
				_self._assets && _self._assets.showFireRopes();
			}, 400);

			return _self._fsAnims.play();
		});

	}).then(function() {

		if(!_self._reelsSpinner)
		{
			return;
		}

		var spinProm = _self._reelsSpinner.spin().then(function() {

			return _self._reelsStop([[0, 1], [1, 0], [2, 1], [3, 2]]);

		});

		_self._spinReels.prepareResult([
			[6, 0, 1],
			[0, 3, 2],
			[4, 0, 6],
			[7, 3, 0],
			[3, 5, 8]
		]);

		_self._stopSpin();

		return spinProm;

	}).then(function() {

		if(!_self._reelsSpinner)
		{
			return;
		}

		var spinProm = _self._reelsSpinner.spin();
		_self._spinReels.prepareResult([
			[6, 0, 1],
			[0, 3, 2],
			[4, 0, 6],
			[7, 3, 0],
			[3, 0, 8]
		]);

		_self._stopSpin();

		return spinProm;
	}).then(function() {

		if(!_self._reelsSpinner)
		{
			return;
		}

		return _self._reelsStop([[4, 1]]);
	}).then(function() {

		if(!_self._reelsSpinner)
		{
			return;
		}

		_self._runRespin();
	});

	this._spinReels.prepareResult([
		[1, 1, 1],
		[8, 0, 11],
		[3, 3, 11],
		[7, 11, 2],
		[6, 6, 6]
	]);

	this._stopSpin();
};

PreinfoFreespins.prototype._reelsStopFs = function(positions) {

	var _self = this;

	return new Promise(function(res) {

		if(!_self._reelsSpinner)
		{
			return res();
		}

		var resSymbols = _self._spinReels.getResSymbols(positions);
		_self._playWinAnim(resSymbols).then(res);
	});

};

PreinfoFreespins.prototype._reelsStop = function(positions) {

	var _self = this;

	return new Promise(function(res) {

		var resSymbols = _self._spinReels.getResSymbols(positions);
		var stickSymbols = _self._symbolsManager.createStickySymbols(resSymbols);

		for(var i = 0; i < stickSymbols.length; i++) {
			_self._stickSymbols.push(stickSymbols[i]);
		}

		var arrowAnims = [];

		for(var i = 0; i < positions.length; i++) {

			var reelX = positions[i][0];

			var arrow = new Arrow();
			arrow.create(reelX);
			arrow.setScale(_self._symbScale, _self._symbScale);

			stickSymbols[i].createStickSymbol(true);
			stickSymbols[i].setScale(_self._symbScale, _self._symbScale);

			arrow.setFrom(MI.getWi() / 4, MI.getHe() * 3 / 4);
			arrow.setToSymbol(stickSymbols[i]);
			stickSymbols[i].setArrow(arrow);

			(function(arrow, i) {
				arrow.setOnHit(function() {
					resSymbols[i].setVisible(false);
					stickSymbols[i].burn();
				});
			} (arrow, i));

			arrow.fadeIn();
			var p = arrow.play();
			arrowAnims.push(p);
		}

		Promise.all(arrowAnims).then(res);
	});
};

PreinfoFreespins.prototype._runRespin = function() {

	if(!this._reelsSpinner) {
		return;
	}

	this._reelsSpinner.spin().then(this._respinStop.bind(this));

	this._spinReels.prepareResult([
		[5, 0, 3],
		[0, 2, 4],
		[6, 0, 8],
		[3, 1, 0],
		[4, 0, 2]
	]);

	this._stopSpin();
};

PreinfoFreespins.prototype._respinStop = function() {

	var _self = this;

	this.destroyStickSymbols();

	var resSymbols = this._spinReels.getResSymbols([
		[0, 1], [1, 0], [2, 1], [3, 2], [4, 1]
	]);

	this._playWinAnim(resSymbols).then(function() {
		_self._respinRestart();
	});
};

PreinfoFreespins.prototype._respinRestart = function() {

	var _self = this;

	_self._assets.hideFireRopes();

//	this._reelsSpinner.spin().then(function() {
		_self._unsetActive();
		_self._animRunning = false;
//		console.timeEnd('t');
//	});
//	this._spinReels.prepareResult(this._serverConfig.getReelMatrix());
//	this._stopSpin();
};

/** @param {boolean} anim */
PreinfoFreespins.prototype.setActive = function(anim) {

	this._btnShine.setVisible(true);
	if (systemConfig.get(CONFIG_PARAMS.LANGUAGE) === "es") {
		this._btn.setFrameName("free-spins_es_active");
	} else {
		this._btn.setFrameName("free-spins_active");
	}

	anim && this._setBtnActive();
};

PreinfoFreespins.prototype._unsetActive = function() {


	if (systemConfig.get(CONFIG_PARAMS.LANGUAGE) === "es") {
		this._btn.setFrameName("free-spins_es");
	} else {
		this._btn.setFrameName("free-spins");
	}

};

PreinfoFreespins.prototype.destroyStickSymbols = function() {

	for(var i = 0; i < this._stickSymbols.length; i++) {
		this._stickSymbols[i].removeStick();
		this._stickSymbols[i].destroyStick();
	}
	this._stickSymbols.length = 0;
};

PreinfoFreespins.prototype._removeTimers = function() {
	for(var i = 0; i < this._timers.length; i++) {
		this._timers[i].stop();
	}
	this._timers.length = 0;
};

PreinfoFreespins.prototype.destroy = function() {

	this._gameConfig = null;

	this._fsAnims.destroy();

	this._assets.destroyFireRopes();

	this._assets = null;

	this._spinReels.destroy();
	this._reelsSpinner = null;

	this.destroyStickSymbols();

	this._removeTimers();

	this._destroyAnims();

	this._stopBtnTween();
	this._destroyBtns();

	this._symbolsManager = null;
};